import React, { useState } from "react";
import PropTypes from "prop-types";

import Tab from "./Tab";

import { TabsContainer } from "./styles";

const Tabs = ({ onTabClick, tabData, defaultTabIndex = 0 }) => {
    const [activeTabIndex, setActiveTabIndex] = useState(defaultTabIndex);

    return (
        <TabsContainer>
            {tabData.map((tab, index) => (
                <Tab
                    onClick={() => {
                        if (activeTabIndex === index) return;

                        !!onTabClick && onTabClick(index);
                        setActiveTabIndex(index);
                    }}
                    key={tab.name}
                    isActive={activeTabIndex === index}
                    icon={tab.icon}
                    href={tab.href}
                >
                    {tab.name}
                </Tab>
            ))}
        </TabsContainer>
    );
};

Tabs.propTypes = {
    tabData: PropTypes.array.isRequired,
    defaultTabIndex: PropTypes.number,
    onTabClick: PropTypes.func
};

export default Tabs;
